import { useEffect } from 'react';

import {
  OnboardingStepReachedProperties,
  ampli,
} from 'src/lib/analytics/amplitude/vendor';

export const useTrackOnboardingStep = (
  Step: OnboardingStepReachedProperties['Step'],
) => {
  useEffect(() => {
    switch (Step) {
      case 'Endpoint Selection':
        ampli.endpointSelectionViewed();
        break;
      case 'Overview':
        ampli.onboardingOverviewViewed();
        break;
      case 'Router Settings':
        ampli.routerSettingsViewed();
        break;
      case 'Summary':
        ampli.onboardingSummaryViewed();
        break;
      case 'Endpoint Details':
        ampli.endpointDetailsViewed();
        break;
      case 'Graph Details':
        ampli.graphDetailsViewed();
        break;
      default:
        // do nothing and fall through;
        break;
    }

    // These events are to be replaced by the previous event via staged
    // deprecation.
    // https://apollographql.atlassian.net/browse/ONB-50 is tracking their
    // removal, likely in july 2024.

    ampli.onboardingStepReached({
      Step,
    });
  }, [Step]);
};
